<link href="https://storage.googleapis.com/code.getmdl.io/1.0.0/material.indigo-pink.min.css" rel="stylesheet">
<div class="toolbar" role="banner">
    <img height="50px" src="../assets/logo-gris.png" (click)="stepper.selectedIndex=0;">
    <div class="spacer"></div>
    <div *ngIf="modoConsulta" style="margin-right: 20px; background-color: #ac1a1f; display: block; padding: 10px 20px; color: #FFF">Modo Consulta</div>
</div>
<mat-horizontal-stepper #stepper [linear]="true" style="margin-top: 100px;">
    <mat-step *ngIf="!modoConsulta" [stepControl]="datosFormGroup" label="step-datos-cliente">
        <div style="text-align: center;">
            <h2>Completá los datos y empezá a diseñar tu crédito</h2>
        </div>
        <div class="card-container">
            <form [formGroup]="datosFormGroup" class="no-padding">
                <mat-form-field appearance="fill" class="form-field-custom">
                    <mat-label>NOMBRE y APELLIDO/RAZÓN SOCIAL</mat-label>
                    <input formControlName="nombre" matInput type="text" autocomplete="off">
                    <mat-error *ngIf="datosFormGroup.get('nombre').hasError('required')">
                        Campo requerido
                    </mat-error>
                </mat-form-field>
                <br>
                <mat-form-field appearance="fill" class="form-field-custom">
                    <mat-label>CUIT</mat-label>
                    <input formControlName="cuit" matInput type="text" autocomplete="off" maxlength="11">
                    <mat-error
                        *ngIf="datosFormGroup.get('cuit').hasError('pattern') &&!datosFormGroup.get('cuit').hasError('required')">
                        Cuit inválido - solo admite números (11 dígitos)
                    </mat-error>
                    <mat-error *ngIf="datosFormGroup.get('cuit').hasError('required')">
                        Cuit requerido
                    </mat-error>
                </mat-form-field>
                <br>
                <mat-form-field appearance="fill" class="form-field-custom">
                    <mat-label>CELULAR</mat-label>
                    <input formControlName="celular" matInput type="text" autocomplete="off">
                    <mat-error
                        *ngIf="datosFormGroup.get('celular').hasError('pattern') &&!datosFormGroup.get('celular').hasError('required')">
                        Celular inválido - ingresá código de área sin el 0 y sin el 15
                    </mat-error>
                    <mat-error *ngIf="datosFormGroup.get('celular').hasError('required')">
                        Celular requerido
                    </mat-error>
                </mat-form-field>
                <br>
                <mat-form-field appearance="fill" class="form-field-custom" [hidden]="true">
                    <mat-label>Celular</mat-label>
                    <input formControlName="celular" matInput type="text" autocomplete="off">
                    <mat-error
                        *ngIf="datosFormGroup.get('celular').hasError('pattern') &&!datosFormGroup.get('celular').hasError('required')">
                        Celular inválido - solo admite números
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="fill" class="form-field-custom">
                    <mat-label>CORREO ELECTRÓNICO</mat-label>
                    <input formControlName="email" matInput type="email" autocomplete="off">
                    <mat-error
                        *ngIf="datosFormGroup.get('email').hasError('pattern') &&!datosFormGroup.get('email').hasError('required')">
                        Email inválido
                    </mat-error>
                    <mat-error *ngIf="datosFormGroup.get('email').hasError('required')">
                        Email requerido
                    </mat-error>
                </mat-form-field>

                <br>
                <button (click)="setDatos();" class="boton-rojo-ftyc" mat-raised-button matStepperNext>Continuar
                </button>

            </form>

        </div>
    </mat-step>

    <mat-step [stepControl]="pymeNuevaFormGroup" label="step-es-pymenueva">
        <div style="text-align: center;">
            <div style="display: flex; justify-content: center">
                <span style="padding-top: 5px;padding-left: 40px;">
                    <h2>¿Sos una <b>PyME</b> nueva?</h2>
                </span>
                <span>
                    <ng-template #pymeNuevaContent>
                        <div>Se consideran Start Ups o PyMES nuevas a aquellas personas o empresas que se están
                            iniciando en una actividad económica.</div>
                        <div><br>Recordá que tanto monotributistas como responsables inscriptos son considerados PyMES.
                        </div>
                    </ng-template>
                    <button mat-icon-button [ngbPopover]="pymeNuevaContent" popoverClass="popOverCustomClass"
                        [placement]="!isMobile?'right-top':'bottom-right'">
                        <mat-icon>help</mat-icon>
                    </button>

                </span>
            </div>
            <button (click)="esPymeNueva(true, stepper);" class="boton-rojo-ftyc" mat-raised-button>SI</button>
            <button (click)="esPymeNueva(false, stepper);" class="boton-rojo-ftyc" mat-raised-button>NO</button>
            <br>

            <div *ngIf="!modoConsulta" class="botonera" style="margin-top: 100px">
                <button class="boton-gris-ftyc" mat-raised-button matStepperPrevious>Volver</button>
                <br>
            </div>
        </div>
    </mat-step>

    <mat-step [stepControl]="financiarFormGroup" label="step-objeto-financiable">
        <div style="text-align: center;">
            <div style="display: flex; justify-content: center">
                <span style="padding-top: 5px;padding-left: 40px;">
                    <h2>¿Qué querés financiar?</h2>
                </span>
                <span>
                    <button mat-icon-button
                        ngbPopover="{{pymeNueva?'Tené en cuenta que para las PyMES nuevas no se financia Capital de Trabajo.&#13;&#13;Recordá que en el FTyC no financiamos la compra de objetos usados.':'Recordá que en el FTyC no financiamos la compra de objetos usados.'}}"
                        popoverClass="popOverCustomClass" [placement]="!isMobile?'right':'bottom-right'">
                        <mat-icon>error</mat-icon>
                    </button>
                </span>
            </div>
            <mat-accordion>
                <div class="demo-grid-ruler mdl-grid">
                    <ng-container *ngFor="let categoria of categoriasObjetosFinanciables; let index = index">
                        <ng-container *ngIf="index < categoriasObjetosFinanciables.length/2">
                            <div class="mdl-cell mdl-cell--6-col">
                                <div class="mdl-cell mdl-cell--12-col" [@.disabled]="disableAnimation">
                                    <mat-expansion-panel [expanded]="false">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title
                                                [ngClass]="checkAccepted(categoriasObjetosFinanciables[index].objetosFinanciables) ? 'higlightItemSelected' : ''">
                                                {{categoriasObjetosFinanciables[index].nombre}}
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>
                                        <ng-template matExpansionPanelContent>
                                            <mat-action-row>
                                                <span class="example-list-section">
                                                    <ul [style]="isMobile? 'padding:0px': ''">
                                                        <li mat-icon-button
                                                            *ngFor="let item of categoriasObjetosFinanciables[index].objetosFinanciables; let myIndex = index">
                                                            <mat-checkbox ngbPopover="{{item.informacionExtra}}"
                                                                popoverClass="popOverCustomClass" [placement]="'top'"
                                                                (click)="setFinanciar($event, item)"
                                                                [ngClass]="item.accepted ? 'higlightItemSelected' : ''"
                                                                [checked]="item.accepted" [(ngModel)]="item.accepted">{{
                                                                item.nombre }}</mat-checkbox>
                                                        </li>
                                                    </ul>
                                                </span>
                                            </mat-action-row>
                                        </ng-template>
                                    </mat-expansion-panel>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="index > categoriasObjetosFinanciables.length/2">
                            <div class="mdl-cell mdl-cell--6-col"
                                *ngIf="index > categoriasObjetosFinanciables.length/2">
                                <div class="mdl-cell mdl-cell--12-col" [@.disabled]="disableAnimation">
                                    <mat-expansion-panel [expanded]="false">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title
                                                [ngClass]="checkAccepted(categoriasObjetosFinanciables[index].objetosFinanciables) ? 'higlightItemSelected' : ''">
                                                {{categoriasObjetosFinanciables[index].nombre}}
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>
                                        <ng-template matExpansionPanelContent>
                                            <mat-action-row>
                                                <span class="example-list-section">
                                                    <ul>
                                                        <li mat-icon-button
                                                            *ngFor="let item of categoriasObjetosFinanciables[index].objetosFinanciables; let myIndex = index">
                                                            <mat-checkbox ngbPopover="{{item.informacionExtra}}"
                                                                popoverClass="popOverCustomClass" [placement]="'top'"
                                                                (click)="setFinanciar($event, item)"
                                                                [ngClass]="item.accepted ? 'higlightItemSelected' : ''"
                                                                [checked]="item.accepted" [(ngModel)]="item.accepted">{{
                                                                item.nombre }}</mat-checkbox>
                                                        </li>
                                                    </ul>
                                                </span>
                                            </mat-action-row>
                                        </ng-template>
                                    </mat-expansion-panel>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </mat-accordion>
            <div class="">
                <button class="boton-gris-ftyc" mat-raised-button (click)="volverPymeNueva(stepper)"> Volver</button>
                <button *ngIf="tiposDestinosSeleccionados.length > 0" class="boton-rojo-ftyc" mat-raised-button
                    matStepperNext>Continuar
                </button>
            </div>

        </div>
    </mat-step>

    <mat-step *ngIf="pymeNueva==true" [stepControl]="financiarFormGroup" label="step-sector-pymenueva">
        <div style="text-align: center;">
            <div style="text-align: center;">
                <div style="display: flex; justify-content: center">
                    <span style="padding-top: 5px;padding-left: 40px;">
                        <h2>¿En qué sector vas a desarrollar tu actividad?</h2>
                    </span>
                </div>
                <div style="display: flex; justify-content: center;">
                    <div class="col-lg-3 col-sm-12">
                        <div class="row justify-content-center">
                            <div class="col-12" style="padding-left: 0px;"
                                *ngFor="let categoriaEmpresa of categoriasEmpresa">
                                <button *ngIf="categoriaEmpresa.id == 1" style="width: 100%"
                                    (click)="setCategoria(categoriaEmpresa, stepper)" class="boton-rojo-ftyc"
                                    mat-raised-button matStepperNext>Agrícola
                                </button>
                                <button *ngIf="categoriaEmpresa.id == 2" style="width: 100%"
                                    (click)="setCategoria(categoriaEmpresa, stepper)" class="boton-rojo-ftyc"
                                    mat-raised-button matStepperNext>Otros sectores
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="botonera">
                    <button class="boton-gris-ftyc" mat-raised-button matStepperPrevious>Volver</button>
                    <br>
                </div>
            </div>
        </div>
    </mat-step>

    <mat-step [stepControl]="financiarFormGroup" label="step-sector-mipyme">
        <div *ngIf="!pymeNueva" style="text-align: center;">
            <div style="text-align: center;">
                <div style="display: flex; justify-content: center">
                    <span style="padding-top: 5px;padding-left: 40px;">
                        <h2>¿Cuál es tu sector según el Certificado MiPyME?</h2>
                    </span>
                    <span>
                        <button mat-icon-button (click)="mostrarCertificado()"
                            (mouseenter)="!isMobile? mostrarCertificado(): false">
                            <mat-icon>help</mat-icon>
                        </button>
                    </span>
                </div>
                <div class="row justify-content-center">
                    <div class="col-lg-6 col-sm-12">
                        <h4 style="margin: 0px;">Elegí la actividad actual y principal de tu empresa que consigna el
                            Certificado MiPyME, sin importar lo que vayas a financiar con este crédito.</h4>
                    </div>
                </div>
                <div style="display: flex; justify-content: center;">
                    <div class="col-lg-3 col-sm-12">
                        <div class="row justify-content-center">
                            <div class="col-12" style="padding-left: 0px;"
                                *ngFor="let sectorEconomico of configuracion?.sectoresEconomicos">
                                <button style="width: 100%" (click)="setSectorEconomico(sectorEconomico)"
                                    class="boton-rojo-ftyc" mat-raised-button matStepperNext>{{sectorEconomico.nombre}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="botonera">
                    <button class="boton-gris-ftyc" mat-raised-button matStepperPrevious>Volver</button>
                    <br>
                </div>
            </div>
        </div>
    </mat-step>

    <mat-step *ngIf="!pymeNueva && esSectorAgropecuario()" [stepControl]="financiarFormGroup" label="step-actividad-principal">
        <div style="text-align: center;">
            <h2>¿Cuál es tu actividad Principal?</h2>
            <div style="display: flex; justify-content: center;">
                <div class="col-lg-3 col-sm-12">
                    <div class="row justify-content-center">
                        <div class="col-12" style="padding-left: 0px;">
                            <button style="width: 100%" (click)="setSectorAgricola(true)" class="boton-rojo-ftyc"
                                mat-raised-button matStepperNext>
                                Agrícola
                            </button>
                            <br>
                            <button style="width: 100%" (click)="setSectorAgricola(false)" class="boton-rojo-ftyc"
                                mat-raised-button matStepperNext>
                                Ganadera
                            </button>
                            <br>
                        </div>
                    </div>
                </div>
            </div>
            <div class="botonera">
                <button class="boton-gris-ftyc" mat-raised-button matStepperPrevious>Volver</button>
                <br>
            </div>
        </div>
    </mat-step>

    <mat-step *ngIf="!pymeNueva" [stepControl]="financiarFormGroup" label="step-categoria-mipyme">
        <div *ngIf="!esSectorAgricola()" style="text-align: center;">

            <div style="display: flex; justify-content: center">
                <span style="padding-top: 5px;padding-left: 40px;">
                    <h2>¿Cuál es tu categoría según el Certificado MiPyME?</h2>
                </span>
                <span>
                    <ng-template #certificadoPyme>
                        <div> El Certificado MiPyME categoriza a las empresas según su facturación anual. Si querés mas
                            información ingresá <a
                                href="https://www.argentina.gob.ar/noticias/nuevas-categorias-para-ser-pyme-3"
                                style="color: white !important;; font-weight: bold" target="_blank">aquí</a>.</div>
                    </ng-template>
                    <button mat-icon-button [ngbPopover]="certificadoPyme" popoverClass="popOverCustomClass"
                        [placement]="!isMobile?'right-top':'bottom-right'">
                        <mat-icon>help</mat-icon>
                    </button>
                </span>
            </div>
            <div style="display: flex; justify-content: center;">
                <div class="col-lg-3 col-sm-12">
                    <div class="row">
                        <ng-container *ngFor="let categoriaEmpresa of categoriasEmpresa">
                            <div class="col-12" *ngIf="!categoriaEmpresa.oculto">
                                <div class="row justify-content-center">
                                    <div class="col-12" style="padding-left: 0px;">
                                        <button style="width: 100%" (click)="setCategoria(categoriaEmpresa, stepper)"
                                            class="boton-rojo-ftyc" mat-raised-button>{{ categoriaEmpresa.nombre.includes('Pequeña Tramo 1') ? categoriaEmpresa.nombre.replace('Tramo 1', '') : categoriaEmpresa.nombre }}
                                        </button>
                                        <br>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="botonera">
                <button class="boton-gris-ftyc" mat-raised-button matStepperPrevious>Volver</button>
                <br>
            </div>
        </div>
        <div *ngIf="esSectorAgricola()" style="text-align: center;">

            <div style="display: flex; justify-content: center">
                <span style="padding-top: 5px;padding-left: 40px;">
                    <h2>¿Cuántas hectáreas explotás según el <b>RUT</b>?</h2>
                </span>
                <span>
                    <ng-template #certificadoRUT>
                        <div> En el RUT se identifica las propiedades rurales de uso agrícola y la cantidad de hectáreas
                            que cada una explota. Si querés más info ingresá <a
                                href="http://www.contingencias.mendoza.gov.ar/web1/rut/rut.html"
                                style="color: white !important;; font-weight: bold" target="_blank">aquí</a>.</div>
                    </ng-template>
                    <button mat-icon-button [ngbPopover]="certificadoRUT" popoverClass="popOverCustomClass"
                        [placement]="!isMobile?'right-top':'bottom-right'">
                        <mat-icon>help</mat-icon>
                    </button>
                </span>
            </div>
            <div style="display: flex; justify-content: center;">
                <div style="display: flex; justify-content: center;">
                    <div class="col-lg-3 col-sm-12">
                        <div class="row">
                            <div class="col-12" *ngFor="let sectorAgricola of getCategoriasAgricolasFiltradas()">
                                <div class="row justify-content-center">
                                    <div class="col-12" style="padding-left: 0px;">
                                        <button style="width: 100%" (click)="setHectareas(sectorAgricola, stepper)"
                                            class="boton-rojo-ftyc" mat-raised-button>{{sectorAgricola.nombre}}
                                        </button>
                                        <br>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="botonera">
                <button class="boton-gris-ftyc" mat-raised-button matStepperPrevious>Volver</button>
                <br>
            </div>
        </div>

    </mat-step>

    <!-- UNA LINEA DE SIMULACION -->
    <mat-step label="">
        <ng-container *ngIf="showSimulacion">
            <app-simulador *ngIf="cantidadSimulaciones > 0" [actividad]="actividad" [categoria]="categoriaInicial"
                [destinoSeleccionado]="destinosSeleccionados[0]" [hectareas]="hectareas" [pymeNueva]="pymeNueva"
                [sectorAgricola]="sectorAgricola" [categoriaAgricola]="categoriaAgricola"
                [sectorEconomico]="sectorEconomico" [configuracion]="configuracion" [cliente]="cliente"
                [stepper]="stepper" (limpiarDestinoSeleccionadoEmit)="limpiarDestinoSeleccionado()">
            </app-simulador>
        </ng-container>

    </mat-step>

</mat-horizontal-stepper>
